import { render, staticRenderFns } from "./DataAnalysisDashboardViewDetailsComponent.vue?vue&type=template&id=206ecc05"
import script from "./DataAnalysisDashboardViewDetailsComponent.vue?vue&type=script&lang=js"
export * from "./DataAnalysisDashboardViewDetailsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports